(function () {
  if (window.__fukGoogleReviewsBoot) return;
  window.__fukGoogleReviewsBoot = true;

  function prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function measureComment(comment, button) {
    if (!comment || !button) return;
    if (comment.classList.contains("is-expanded")) {
      button.hidden = false;
      return;
    }
    button.hidden = comment.scrollHeight <= comment.clientHeight + 1;
  }

  function setupComments(root) {
    var comments = root.querySelectorAll("[data-fuk-comment]");

    function remeasure() {
      comments.forEach(function (comment) {
        var button = comment.parentElement && comment.parentElement.querySelector("[data-fuk-more]");
        measureComment(comment, button);
      });
    }

    comments.forEach(function (comment) {
      var button = comment.parentElement && comment.parentElement.querySelector("[data-fuk-more]");
      if (!button) return;
      button.addEventListener("click", function () {
        var open = comment.classList.toggle("is-expanded");
        button.setAttribute("aria-expanded", open ? "true" : "false");
        button.textContent = open ? "Weniger anzeigen" : "Weiterlesen";
        if (!open) measureComment(comment, button);
        root.dispatchEvent(new CustomEvent("fuk-reviews:refresh"));
      });
    });

    remeasure();
    return remeasure;
  }

  function setupSlider(root) {
    if (root.getAttribute("data-fuk-layout") !== "karussell") return function () {};
    var slider = root.querySelector("[data-fuk-slider]");
    var track = root.querySelector("[data-fuk-track]");
    var prev = root.querySelector("[data-fuk-prev]");
    var next = root.querySelector("[data-fuk-next]");
    if (!slider || !track) return function () {};

    function cardStep() {
      var card = track.querySelector(".fuk-reviews__card");
      if (!card) return track.clientWidth || 1;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function scrollByCard(direction) {
      var max = track.scrollWidth - track.clientWidth;
      if (max <= 1) return;
      track.scrollBy({
        left: direction * cardStep(),
        behavior: prefersReducedMotion() ? "auto" : "smooth"
      });
    }

    function updateSlider() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth;
      var canScroll = max > 1;
      prev.hidden = !canScroll;
      next.hidden = !canScroll;
      if (!canScroll) return;
      prev.setAttribute("aria-disabled", track.scrollLeft <= 1 ? "true" : "false");
      next.setAttribute("aria-disabled", track.scrollLeft >= max - 1 ? "true" : "false");
    }

    if (prev) {
      prev.addEventListener("click", function () {
        if (prev.getAttribute("aria-disabled") === "true") return;
        scrollByCard(-1);
      });
    }
    if (next) {
      next.addEventListener("click", function () {
        if (next.getAttribute("aria-disabled") === "true") return;
        scrollByCard(1);
      });
    }

    slider.addEventListener("keydown", function (event) {
      if (event.key !== "ArrowRight" && event.key !== "ArrowLeft") return;
      var target = event.target;
      if (target && target.closest && target.closest("a, summary, [data-fuk-more]")) return;
      if (track.scrollWidth - track.clientWidth <= 1) return;
      event.preventDefault();
      scrollByCard(event.key === "ArrowRight" ? 1 : -1);
    });

    track.addEventListener("scroll", updateSlider, { passive: true });
    updateSlider();
    return updateSlider;
  }

  function init(root) {
    if (root.getAttribute("data-fuk-ready") === "true") return;
    root.setAttribute("data-fuk-ready", "true");

    var remeasure = setupComments(root);
    var updateSlider = setupSlider(root);
    var frame = 0;

    function refresh() {
      if (frame) return;
      frame = window.requestAnimationFrame(function () {
        frame = 0;
        remeasure();
        updateSlider();
      });
    }

    root.addEventListener("fuk-reviews:refresh", refresh);
    window.addEventListener("resize", refresh);
    if (window.ResizeObserver) {
      var layout = root.querySelector(".fuk-reviews__layout");
      if (layout) new ResizeObserver(refresh).observe(layout);
    }
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        if (root.isConnected) refresh();
      });
    }
  }

  function boot() {
    document.querySelectorAll("[data-fuk-reviews]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", boot);
})();
